import { useEffect } from 'react';

// Escape closes a hand-built overlay and marks the key handled, so SubNav's
// window handler (which skips defaultPrevented) and Modal's chain leave it alone.
// It listens in the bubble phase on document, after any Select, DatePicker or
// menu inside the overlay: one that has an open list handles the key first and
// the overlay stays open.
export function useEscapeClose(active: boolean, onClose: () => void) {
  useEffect(() => {
    if (!active) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== 'Escape' || e.defaultPrevented) return;
      e.preventDefault();
      onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [active, onClose]);
}
